import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import { H2, H3 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
export default function VideoSection() {
  const {
    width
  } = useResponsiveProps({
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '75%'
    }
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "is--heading-1 text-center p-top-5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.video.title"
      })
    }), /*#__PURE__*/_jsx(H3, {
      className: "is--heading-2 text-center m-bottom-10",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.video.subtitle"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "p-y-10",
      style: {
        margin: 'auto',
        width
      },
      children: /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
        autoPlay: true,
        mutedByDefault: true,
        videoId: 124830715965
      })
    })]
  });
}